export default __webpack_public_path__ + "static/thumb-landscape-3793b0f2f7b6ecbfd06909e0748acd5d.jpg";